<template>
  <div class="header-wrap">
    <div class="title">明禧猫公寓后台管理</div>
    <div class="user-info">
      <span>{{ admin.real_name }}</span>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <i class="el-icon-user"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState({
      admin: state => state.user.admin
    })
  },
  methods: {
    ...mapActions(['logout']),
    handleCommand(cmd) {
      if (cmd === 'logout') {
        this.$confirm('确定退出当前账号？', '提示').then(() => {
          this.logout()
          this.$router.push('/login')
        })
      }
    }
  }
}
</script>
<style scoped>
.header-wrap {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
}
.title {
  font-size: 18px;
  font-weight: 500;
}
.user-info {
  display: flex;
  gap: 16px;
  align-items: center;
}
</style>
